<section class="user-editor-page">
  <app-entity-photos *ngIf="isSelfProfile && photoPersonId" [id]="photoPersonId!" [displayName]="userFullName" />
  <header class="user-editor-header">
    <button mat-icon-button (click)="goBack()" [matTooltip]="isSelfProfile ? 'Volver al inicio' : 'Volver al listado'" [disabled]="isLoading">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h1>{{ isSelfProfile ? 'Mi perfil' : (isEditMode ? 'Detalle de usuario' : 'Crear usuario') }}</h1>
      <p>{{ isEditMode ? 'Consulta los datos de acceso y alcance' : 'Crea un usuario para una persona existente' }}</p>
    </div>
  </header>

  <div *ngIf="isLoading" class="loading-container user-editor-section">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Cargando usuario...</p>
  </div>

  <div *ngIf="loadError && !isLoading" class="error-container user-editor-section">
    <mat-icon color="warn">error</mat-icon>
    <p>{{ loadError }}</p>
  </div>

  <form [formGroup]="editorForm" class="has-form-actions" *ngIf="!isLoading && !isEditMode">
    <div class="user-editor-section">
      <h3>
        <mat-icon>person_search</mat-icon>
        Persona asociada
      </h3>

      <mat-form-field class="full-width">
        <mat-label>Buscar persona sin usuario</mat-label>
        <input
          matInput
          [formControl]="personSearchControl"
          [matAutocomplete]="personAutocomplete"
          placeholder="Nombre, apellido, documento o email" />
        <mat-icon matSuffix>search</mat-icon>
        <mat-autocomplete
          #personAutocomplete="matAutocomplete"
          [displayWith]="displayPerson"
          (optionSelected)="onPersonSelected($event.option.value)">
          <mat-option *ngIf="isSearchingPeople" disabled>
            Buscando...
          </mat-option>
          <mat-option *ngFor="let person of eligiblePeople" [value]="person">
            {{ person.lastName }}, {{ person.firstName }}
            <span *ngIf="person.documentNumber"> - {{ person.documentNumber }}</span>
            <span *ngIf="person.email"> - {{ person.email }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="user-editor-section user-editor-section--reference" *ngIf="selectedPerson">
      <h3>
        <mat-icon>badge</mat-icon>
        Informacion de referencia
      </h3>

      <div class="info-section">
        <div class="info-item">
          <mat-icon class="info-item-icon">person</mat-icon>
          <div class="info-item-content">
            <label>Nombre completo</label>
            <span class="info-item-value">{{ userFullName }}</span>
          </div>
        </div>

        <div class="info-item" *ngIf="userDocument">
          <mat-icon class="info-item-icon">badge</mat-icon>
          <div class="info-item-content">
            <label>Documento</label>
            <span class="info-item-value">{{ userDocument }}</span>
          </div>
        </div>

        <div class="info-item" *ngIf="membershipUnitName">
          <mat-icon class="info-item-icon">church</mat-icon>
          <div class="info-item-content">
            <label>Comunidad de pertenencia</label>
            <span class="info-item-value">{{ membershipUnitName }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="user-editor-section">
      <h3>
        <mat-icon>edit</mat-icon>
        Datos de acceso
      </h3>

      <div class="form-grid form-single-column">
        <mat-form-field class="full-width">
          <mat-label>Nombre de usuario</mat-label>
          <input matInput formControlName="username" placeholder="nombre.usuario" />
          <mat-error *ngIf="editorForm.get('username')?.hasError('required')">
            El nombre de usuario es requerido
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" placeholder="correo@ejemplo.com" />
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="editorForm.get('email')?.hasError('email')">
            El email debe tener un formato valido
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>

  <section class="user-editor-section user-detail-card" *ngIf="!isLoading && isEditMode">
    <div class="profile-header">
      <div class="profile-avatar">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="profile-heading">
        <h3>{{ username || 'Usuario' }}</h3>
      </div>
    </div>

    <mat-tab-group class="profile-tabs" [(selectedIndex)]="selectedDetailTabIndex" animationDuration="0ms">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="profile-tab-label">
            <mat-icon>person</mat-icon>
            Perfil
          </span>
        </ng-template>

        <div class="tab-content profile-data-grid">
          <div class="profile-data-item">
            <span class="profile-data-label">Nombre completo</span>
            <strong>{{ userFullName || '-' }}</strong>
          </div>

          <div class="profile-data-item">
            <span class="profile-data-label">Nombre de usuario</span>
            <strong>{{ username || '-' }}</strong>
          </div>

          <div class="profile-data-item">
            <span class="profile-data-label">Documento</span>
            <strong>{{ userDocument || '-' }}</strong>
          </div>

          <div class="profile-data-item profile-data-item--editable">
            <span class="profile-data-label">Email</span>
            <strong>{{ userEmail || '-' }}</strong>
            <button mat-icon-button type="button" color="primary" matTooltip="Editar email"
              (click)="openEmailDialog()" [disabled]="isSaving">
              <mat-icon>edit</mat-icon>
            </button>
          </div>

          <div class="profile-data-item">
            <span class="profile-data-label">Comunidad de pertenencia</span>
            <strong>{{ membershipUnitName || '-' }}</strong>
          </div>

          <div class="profile-data-item" *ngIf="!hasLocalUser">
            <span class="profile-data-label">Vinculo local</span>
            <strong>Usuario no vinculado a una persona del sistema</strong>
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span class="profile-tab-label">
            <mat-icon>admin_panel_settings</mat-icon>
            Roles
          </span>
        </ng-template>

        <div class="tab-content access-tab-content">
          <section *ngIf="!hasLocalUser; else roleAssignmentsEditor" class="unlinked-role-message">
            <mat-icon>link_off</mat-icon>
            <div>
              <h4>Usuario sin persona vinculada</h4>
              <p>Para asignar roles al usuario primero hay que vincularlo con una persona del sistema.</p>
            </div>
          </section>

          <ng-template #roleAssignmentsEditor>
          <section class="role-assignment-editor">
            <app-table-surface
              tableId="user-editor-role-assignments"
              title="Roles asignados"
              titleIcon="admin_panel_settings"
              [columns]="isSelfProfile ? selfRoleAssignmentColumns : roleAssignmentColumns"
              [data]="displayedRoleAssignments"
              [isLoading]="isSaving"
              noDataMessage="Sin asignaciones de acceso"
              [enableRowHover]="false"
              [tableHeight]="'auto'"
              [enableSearch]="true"
              searchPlaceholder="Buscar rol o unidad..."
              [enableSort]="true"
              [sortState]="roleAssignmentSortState"
              [enableColumnVisibility]="true"
              [enableDensity]="true"
              primaryActionMobileLabel="Agregar"
              [readonly]="isSelfProfile || isSaving || !hasLocalUser"
              [cellTemplate]="roleAssignmentCell"
              (searchChange)="onRoleAssignmentSearch($event)"
              (toolbarSortChange)="onRoleAssignmentSort($event)"
              (primaryActionClick)="openRoleAssignmentDialog()">
            </app-table-surface>

            <ng-template #roleAssignmentCell let-column="column" let-row="row">
              <span *ngIf="column === 'role'" class="role-chip">
                {{ getRoleLabel(row.role) }}
              </span>

              <div *ngIf="column === 'unit'" class="assignment-unit-cell">
                <span>{{ row.organizationUnitName || 'Unidad asignada' }}</span>
                <div class="assignment-scope" *ngIf="row.organizationUnitLevelId && row.organizationUnitLevelId < 5">
                    <mat-icon>account_tree</mat-icon>
                    <span>Incluye unidades de nivel inferior</span>
                </div>
              </div>

              <div *ngIf="column === 'actions' && !isSelfProfile" class="assignment-actions">
                <button mat-icon-button color="primary" type="button" matTooltip="Editar asignación"
                  (click)="openRoleAssignmentDialog(row)" [disabled]="isSaving">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" type="button" matTooltip="Quitar asignación"
                  (click)="removeRoleAssignment(row)" [disabled]="isSaving">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </ng-template>
          </section>
          </ng-template>
        </div>
      </mat-tab>

      <mat-tab *ngIf="!isSelfProfile && hasLocalUser">
        <ng-template mat-tab-label>
          <span class="profile-tab-label">
            <mat-icon>history</mat-icon>
            Actividad
          </span>
        </ng-template>

        <div class="tab-content activity-tab-content">
          <section class="activity-summary">
            <div class="activity-summary-item activity-summary-item--wide">
              <span>Ultima actividad</span>
              <strong>{{ activitySummary?.lastActivity ? formatDateTime(activitySummary?.lastActivity?.timestampUtc) : '-' }}</strong>
              <small *ngIf="activitySummary?.lastActivity">
                {{ getActionLabel(activitySummary?.lastActivity?.actionType) }} · {{ activitySummary?.lastActivity?.details }}
              </small>
            </div>

            <div class="activity-summary-item">
              <span>Total registrado</span>
              <strong>{{ activitySummary?.totalCount ?? 0 }}</strong>
            </div>

            <div class="activity-summary-item">
              <span>Ultimos 7 dias</span>
              <strong>{{ activitySummary?.last7DaysCount ?? 0 }}</strong>
            </div>

            <div class="activity-summary-item">
              <span>Ultimos 30 dias</span>
              <strong>{{ activitySummary?.last30DaysCount ?? 0 }}</strong>
            </div>
          </section>

          <section class="activity-type-list" *ngIf="activitySummary?.countsByActionType?.length">
            <span *ngFor="let item of activitySummary?.countsByActionType">
              {{ getActionLabel(item.actionType) }}: {{ item.count }}
            </span>
          </section>

          <div class="activity-actions">
            <button mat-stroked-button color="primary" type="button" (click)="openActivityPage()">
              <mat-icon>table_view</mat-icon>
              Ver toda la actividad
            </button>
          </div>
        </div>
      </mat-tab>

      <mat-tab *ngIf="!hasLocalUser && !isSelfProfile">
        <ng-template mat-tab-label>
          <span class="profile-tab-label profile-tab-label--danger">
            <mat-icon>delete</mat-icon>
            Eliminar
          </span>
        </ng-template>

        <div class="tab-content delete-user-tab">
          <section class="delete-user-panel">
            <mat-icon>delete</mat-icon>
            <div>
              <h4>Eliminar usuario del IdP</h4>
              <p>Este usuario no esta vinculado a una persona del sistema. Al eliminarlo se borrara solamente del proveedor de identidad.</p>
            </div>
            <button mat-raised-button color="warn" type="button" (click)="deleteUnlinkedUser()" [disabled]="isDeleting">
              <mat-icon *ngIf="!isDeleting">delete</mat-icon>
              {{ isDeleting ? 'Eliminando...' : 'Eliminar usuario' }}
            </button>
          </section>
        </div>
      </mat-tab>
    </mat-tab-group>
  </section>

  <div class="user-editor-footer" *ngIf="!isLoading && !isEditMode">
    <span class="spacer"></span>
    <button mat-raised-button type="button" (click)="onCancel()" [disabled]="isSaving">
      <mat-icon>cancel</mat-icon>
      Cancelar
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onSave()" [disabled]="isSaving">
      <mat-icon *ngIf="!isSaving">save</mat-icon>
      {{ isSaving ? 'Guardando...' : 'Guardar' }}
    </button>
  </div>

</section>
